import template from './campaign.html';
import controller from './campaign.controller';
import './campaign.scss';

let campaignComponent = {
  bindings: {},
  template,
  controller
};

export default campaignComponent;



// WEBPACK FOOTER //
// ./client/app/components/campaign/campaign.component.js